import React, { useRef, useEffect, useCallback } from 'react';

const extractZip = (str) => {
  const m = (str || '').match(/\b(\d{5})(?:-\d{4})?\b/);
  return m ? m[1] : '';
};

const AddressAutocomplete = ({ value, onChange, placeholder, className, required, ...props }) => {
  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);
  const onChangeRef = useRef(onChange);
  onChangeRef.current = onChange;

  const initAutocomplete = useCallback(() => {
    if (!window.google?.maps?.places || !inputRef.current || autocompleteRef.current) return;

    autocompleteRef.current = new window.google.maps.places.Autocomplete(inputRef.current, {
      types: ['address'],
      componentRestrictions: { country: 'us' },
      fields: ['formatted_address', 'address_components'],
    });

    autocompleteRef.current.addListener('place_changed', () => {
      const place = autocompleteRef.current.getPlace();
      if (place?.formatted_address) {
        let zip = '';
        (place.address_components || []).forEach((c) => {
          if (c.types.includes('postal_code')) zip = c.short_name;
        });
        if (!zip) zip = extractZip(place.formatted_address);
        onChangeRef.current(place.formatted_address, zip, true);
      }
    });
  }, []);

  useEffect(() => {
    if (window.google?.maps?.places) {
      initAutocomplete();
    } else {
      const check = setInterval(() => {
        if (window.google?.maps?.places) {
          clearInterval(check);
          initAutocomplete();
        }
      }, 300);
      return () => clearInterval(check);
    }
  }, [initAutocomplete]);

  useEffect(() => {
    if (inputRef.current && inputRef.current.value !== value) {
      inputRef.current.value = value || '';
    }
  }, [value]);

  return (
    <input
      ref={inputRef}
      type="text"
      className={className}
      defaultValue={value}
      onChange={(e) => onChangeRef.current(e.target.value, extractZip(e.target.value), false)}
      placeholder={placeholder}
      required={required}
      autoComplete="off"
      {...props}
    />
  );
};

export default AddressAutocomplete;
